import React from 'react';
import { QuestionCircleOutlined, ScissorOutlined, TeamOutlined, TrophyOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './Games.css';

const Games: React.FC = () => (
  <div className="games-page games-hub">
    <header className="games-hero">
      <div className="games-eyebrow"><TrophyOutlined /> The archive arcade</div>
      <h1>League Games</h1>
      <p>Settle impossible roster debates and build a head-to-head lineup from league history.</p>
    </header>

    <section className="games-hub-grid">
      <Link to="/games/keep-4-cut-4" className="games-hub-card games-hub-card--keep">
        <span className="games-hub-number">01</span>
        <ScissorOutlined className="games-hub-icon" />
        <div>
          <span className="games-card-kicker">Solo · subjective</span>
          <h2>Keep 4, Cut 4</h2>
          <p>Eight players arrive one at a time. Make the hard call before you know who's next.</p>
        </div>
        <span className="games-card-cta">Choose a category <span aria-hidden="true">→</span></span>
      </Link>

      <Link to="/games/franchise-draft" className="games-hub-card games-hub-card--draft">
        <span className="games-hub-number">02</span>
        <TeamOutlined className="games-hub-icon" />
        <div>
          <span className="games-card-kicker">Two players · pass & play</span>
          <h2>Franchise Draft</h2>
          <p>Draw a random franchise, draft one of its alumni, and build the best eight-player lineup.</p>
        </div>
        <span className="games-card-cta">Start a matchup <span aria-hidden="true">→</span></span>
      </Link>

      <Link to="/games/who-am-i" className="games-hub-card games-hub-card--who">
        <span className="games-hub-number">03</span>
        <QuestionCircleOutlined className="games-hub-icon" />
        <div>
          <span className="games-card-kicker">Solo · configurable hints</span>
          <h2>Who Am I?</h2>
          <p>Follow league and NFL hints while a mystery player's portrait slowly comes into focus.</p>
        </div>
        <span className="games-card-cta">Solve a mystery <span aria-hidden="true">→</span></span>
      </Link>
    </section>
  </div>
);

export default Games;
